import { queryOptions } from "@tanstack/react-query";
import type { ScopedBinding } from "@/app/types";
import type { ApiClient } from "@/lib/api";
import { getEngineApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";
import { sessionVerificationKeys } from "./query-keys";

export type SessionVerificationSettings = {
  unsafe_skip_verification: boolean;
  unsafe_skip_verification_choice_allowed: boolean;
  verifier_url: string | null;
};

export const getSessionVerification = async ({
  client,
}: {
  client: ApiClient;
}): Promise<SessionVerificationSettings> => {
  const { data } = await client.get<SessionVerificationSettings>(
    "/settings/session_verification"
  );
  return data;
};

export const sessionVerificationQueryOptions = ({
  binding = "project",
  scope,
}: {
  binding?: ScopedBinding;
  scope: OrgProjectScope;
}) => {
  const client = getEngineApi(scope, binding);

  return queryOptions({
    queryKey: sessionVerificationKeys.single({ binding, scope }),
    queryFn: () => getSessionVerification({ client }),
  });
};
